var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 12C1 6.477 5.477 2 11 2a9.97 9.97 0 0 1 7.073 2.931c.64.64 1.325 1.431 1.927 2.163V4a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h3.97c-.693-.869-1.553-1.897-2.311-2.655a8 8 0 1 0 2.029 7.878 1 1 0 0 1 1.921.554C19.405 18.948 15.56 22 11 22 5.477 22 1 17.523 1 12",
    clipRule: "evenodd"
  })));
};
export default SvgRefresh;